// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import Active from "../../Assets/Active.jpg";
// import Inactive from "../../Assets/Inactive3.png";
// import Pagination from "react-bootstrap/Pagination";
// import { Spinner } from "react-bootstrap"; // Import Spinner component


// export default function CrudHome() {
//   const [data, setData] = useState([]);
//   const [message, setMessage] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(true); // Loading state
//   const itemsPerPage = 5;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     const filteredResults = data.filter(
//       (student) =>
//         student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         student.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         student.role.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     setFilteredData(filteredResults);
//   }, [data, searchQuery]);

//   const fetchData = () => {
//     setLoading(true); // Start loading
//     axios
//       .get("https://raasbackend.vetrinahealthcare.com/students/")
//       .then((res) => {
//         setData(res.data);
//         setMessage("");
//       })
//       .catch((err) => {
//         console.log(err);
//         setLoading(false); // Stop loading on error
//       });
//   };

//   const handleDelete = (id) => {
//     axios
//       .delete(`https://raasbackend.vetrinahealthcare.com/students/delete/${id}/`)
//       .then((res) => {
//         const updatedData = data.filter((student) => student.id !== id);
//         setData(updatedData);
//         setMessage("Student account deleted successfully.");
//         setTimeout(() => setMessage(""), 3000);
//       })
//       .catch((err) => console.log(err));
//   };

//   const confirmDelete = (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         handleDelete(id);
//       }
//     });
//   };

//   const handleActivate = (id) => {
//     axios
//       .put(`https://raasbackend.vetrinahealthcare.com/students/activate/${id}/`)
//       .then((res) => {
//         fetchData();
//         setMessage("Student account activated successfully.");
//         setTimeout(() => setMessage(""), 3000);
//       })
//       .catch((err) => console.log(err));
//   };

//   const handleDeactivate = (id) => {
//     axios
//       .put(`https://raasbackend.vetrinahealthcare.com/students/deactivate/${id}/`)
//       .then((res) => {
//         fetchData();
//         setMessage("Student account deactivated successfully.");
//         setTimeout(() => setMessage(""), 3000);
//       })
//       .catch((err) => console.log(err));
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   return (
//     <>
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="container main adminuserlist" style={{ marginTop: "25px", marginBottom: "25px" }}>
//           <div className="d-flex justify-content-center align-items-center mt-2">
//             <div className="auth-inner w-100" style={{ padding: "10px 10px 10px 10px" }}>
//               <div className="container">
//                 <div className="row justify-content-center">
//                   <div className="col-lg-12">
//                     <div className="bg-white rounded">
//                       <h2 className="display-6 gradient-text mb-4">
//                         Manage Users
//                       </h2>
//                       <div className="d-flex justify-content-center">
//                         <div className="input-group search2">
//                           <div className="form-outline w-100">
//                             <input
//                               type="search"
//                               className="form-control"
//                               placeholder="Search by Name, Email, or Role"
//                               value={searchQuery}
//                               onChange={(e) => setSearchQuery(e.target.value)}
//                             />
//                             <button
//                               className="btn btn-primary searchicon"
//                               type="button"
//                             >
//                               <i className="fas fa-search"></i>
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="d-flex justify-content-end mb-3">
//                         <Link to="/create" className="btn btn-success">
//                           Create+
//                         </Link>
//                       </div>

//                       {message && (
//                         <div className="alert alert-success">{message}</div>
//                       )}
//                       <div className="table-responsive">
//                         <table className="table">
//                           <thead>
//                             <tr>
//                               <th>ID</th>
//                               <th>Name</th>
//                               <th>Email</th>
//                               <th>Role</th>
//                               <th>Status</th>
//                               <th>Action</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {loading ? (
//                               <tr>
//                                 <td colSpan="6" className="text-center">
//                                   <Spinner animation="border" variant="primary" /> {/* Loader */}
//                                 </td>
//                               </tr>
//                             ) : (
//                               currentItems.map((student, index) => (
//                                 <tr key={index}>
//                                   <td>{student.id}</td>
//                                   <td>{student.name}</td>
//                                   <td>{student.email}</td>
//                                   <td>{student.role}</td>
//                                   <td>
//                                     {student.account_status === "Active" ? (
//                                       <img
//                                         src={Active}
//                                         alt="Active"
//                                         style={{ height: 27, width: 27 }}
//                                       />
//                                     ) : (
//                                       <img
//                                         src={Inactive}
//                                         alt="Inactive"
//                                         style={{ height: 27, width: 27 }}
//                                       />
//                                     )}
//                                   </td>
//                                   <td>
//                                     <Link
//                                       to={`/read/${student.id}`}
//                                       className="btn btn-sm btn-info me-2"
//                                       style={{ marginBottom: "5px" }}
//                                     >
//                                       <i className="fa-solid fa-book" />
//                                     </Link>
//                                     <Link
//                                       to={`/edit/${student.id}`}
//                                       className="btn btn-sm btn-primary me-2"
//                                       style={{ marginBottom: "5px" }}
//                                     >
//                                       <i className="fa-solid fa-pen" />
//                                     </Link>
//                                     <button
//                                       onClick={() => confirmDelete(student.id)}
//                                       className="btn btn-sm btn-danger me-2"
//                                       style={{ marginBottom: "5px" }}
//                                     >
//                                       <i className="fa-solid fa-trash" />
//                                     </button>
//                                     {student.account_status === "Active" ? (
//                                       <button
//                                         onClick={() =>
//                                           handleDeactivate(student.id)
//                                         }
//                                         className="btn btn-sm btn-warning me-2"
//                                         style={{ marginBottom: "5px" }}
//                                       >
//                                         Inactive
//                                       </button>
//                                     ) : (
//                                       <button
//                                         onClick={() =>
//                                           handleActivate(student.id)
//                                         }
//                                         className="btn btn-sm btn-success me-2 pe-3"
//                                         style={{ marginBottom: "5px" }}
//                                       >
//                                         Active
//                                       </button>
//                                     )}
//                                   </td>
//                                 </tr>
//                               ))
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                       <Pagination>
//                         <Pagination.Prev
//                           onClick={() =>
//                             setCurrentPage((prev) =>
//                               prev > 1 ? prev - 1 : prev
//                             )
//                           }
//                         />
//                         {Array.from(
//                           {
//                             length: Math.ceil(filteredData.length / itemsPerPage),
//                           },
//                           (_, index) => (
//                             <Pagination.Item
//                               key={index}
//                               active={index + 1 === currentPage}
//                               onClick={() => paginate(index + 1)}
//                             >
//                               {index + 1}
//                             </Pagination.Item>
//                           )
//                         )}
//                         <Pagination.Next
//                           onClick={() =>
//                             setCurrentPage((prev) =>
//                               prev <
//                                 Math.ceil(filteredData.length / itemsPerPage)
//                                 ? prev + 1
//                                 : prev
//                             )
//                           }
//                         />
//                       </Pagination>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


//New Code.
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Sidebar from "../Misc/Sidebar";
import DashNavbar from "../Misc/DashNavbar";
import Active from "../../Assets/Active.jpg";
import Inactive from "../../Assets/Inactive3.png";
import Pagination from "react-bootstrap/Pagination";
import { Spinner, Form, Card, InputGroup, Table } from "react-bootstrap"; // Import necessary components

const CustomStyles = () => (
  <style>{`
    .crud-home-page .card { flex: 1; display: flex; flex-direction: column; overflow: hidden; border: none; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); margin-bottom: 0 !important; }
    .crud-home-page .card-body { flex: 1; overflow-y: auto; display: flex; flex-direction: column; padding: 0 !important; }
    .crud-home-page .table-container { flex: 1; overflow-y: auto; padding: 0 1.5rem; }
    .crud-home-page .card-header { background: white; border-bottom: 1px solid #edf2f7; padding: 0.75rem 1.5rem; }
    .crud-home-page .card-footer { background: white; border-top: 1px solid #edf2f7; padding: 0.75rem 1.5rem; }
    
    /* Compact Table Styling */
    .crud-home-page .table td { padding: 10px 12px !important; font-size: 14px; vertical-align: middle; }
    .crud-home-page .table th { padding: 12px !important; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; }
    .crud-home-page .search-container { padding: 1.5rem; flex-shrink: 0; background: linear-gradient(to bottom, #ffffff, #fcfcfc); }
    .gradient-text { background: linear-gradient(135deg, #0d6efd 0%, #0043a8 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; font-weight: 700; }
  `}</style>
);


export default function CrudHome() {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filteredResults = data.filter(
      (student) =>
        student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        student.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        student.role.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filteredResults);
  }, [data, searchQuery]);

  const fetchData = () => {
  setLoading(true); // Start loading
  axios
    .get("https://raasbackend.vetrinahealthcare.com/student/")
    .then((res) => {
      // PASTE SORTING LOGIC HERE
      const sortedData = [...res.data].sort((a, b) => {
        // Assuming student.id is a number.
        // If student.id can be a string that needs numeric-like sorting,
        // you might need parseInt(a.id) - parseInt(b.id)
        // or a more robust alphanumeric sort if IDs are mixed.
        // For simple numeric IDs:
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
      setData(sortedData); // Use the sorted data
      // END OF SORTING LOGIC MODIFICATION
      setMessage("");
      setLoading(false); // Stop loading after successful fetch
    })
    .catch((err) => {
      console.log(err);
      setLoading(false); // Stop loading on error
    });
};

  const handleDelete = (id) => {
    axios
      .delete(`https://raasbackend.vetrinahealthcare.com/students/delete/${id}/`)
      .then((res) => {
        const updatedData = data.filter((student) => student.id !== id);
        setData(updatedData);
        setMessage("Student account deleted successfully.");
        setTimeout(() => setMessage(""), 3000);
      })
      .catch((err) => console.log(err));
  };

  const confirmDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const handleActivate = (id) => {
    axios
      .put(`https://raasbackend.vetrinahealthcare.com/students/activate/${id}/`)
      .then((res) => {
        fetchData();
        setMessage("Student account activated successfully.");
        setTimeout(() => setMessage(""), 3000);
      })
      .catch((err) => console.log(err));
  };

  const handleDeactivate = (id) => {
    axios
      .put(`https://raasbackend.vetrinahealthcare.com/students/deactivate/${id}/`)
      .then((res) => {
        fetchData();
        setMessage("Student account deactivated successfully.");
        setTimeout(() => setMessage(""), 3000);
      })
      .catch((err) => console.log(err));
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    const totalItems = filteredData.length;
    const totalPagesCount = Math.ceil(totalItems / itemsPerPage);
    if (pageNumber >= 1 && pageNumber <= totalPagesCount) {
      setCurrentPage(pageNumber);
    }
  };

  const getPageOptions = () => [5, 10, 25, 50, 100];

  const renderPaginationFooter = () => {
    if (loading || data.length === 0) return null;
    
    const totalItems = filteredData.length;
    const totalPagesCount = Math.ceil(totalItems / itemsPerPage);
    const startRecord = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const endRecord = Math.min(currentPage * itemsPerPage, totalItems);

    return (
      <div className="card-footer d-flex justify-content-between align-items-center flex-wrap gap-3 px-4 py-3">
        <div className="text-muted small">
          Showing <b>{startRecord}</b> to <b>{endRecord}</b> of <b>{totalItems}</b> records
        </div>
        
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2 text-nowrap">
            <span className="text-muted small">Rows per page:</span>
            <Form.Select 
              size="sm" 
              value={itemsPerPage} 
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{ width: "70px" }}
            >
              {getPageOptions().map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </Form.Select>
          </div>

          <Pagination size="sm" className="mb-0">
            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
            <Pagination.Item active>{currentPage}</Pagination.Item>
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPagesCount || totalPagesCount === 0} />
            <Pagination.Last onClick={() => handlePageChange(totalPagesCount)} disabled={currentPage === totalPagesCount || totalPagesCount === 0} />
          </Pagination>
        </div>
      </div>
    );
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <DashNavbar />
      <div className="crud-home-page wrapper">
        <Sidebar />
        <main className="main">
          <CustomStyles />
          <div className="container-fluid flex-grow-1 d-flex flex-column p-4">
            <Card className="shadow-sm border-0">
              <Card.Header className="d-flex justify-content-between align-items-center bg-white py-3">
                <h3 className="mb-0 gradient-text">Manage Users</h3>
                <Link to="/create" className="btn btn-primary d-flex align-items-center gap-2 px-3 shadow-sm">
                  <i className="fas fa-plus small"></i>
                  <span>Create User</span>
                </Link>
              </Card.Header>

              <Card.Body>
                <div className="search-container border-bottom bg-light bg-opacity-10">
                  <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8">
                      <InputGroup className="shadow-sm">
                        <InputGroup.Text className="bg-white border-end-0">
                          <i className="fas fa-search text-muted"></i>
                        </InputGroup.Text>
                        <Form.Control
                          className="border-start-0 ps-0"
                          placeholder="Search by Name, Email, or Role..."
                          value={searchQuery}
                          onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                        />
                      </InputGroup>
                    </div>
                  </div>
                </div>

                {message && (
                  <div className="alert alert-success mx-4 mt-3 py-2 small shadow-sm">{message}</div>
                )}

                <div className="table-container my-3 px-4">
                  <Table className="mb-0">
                    <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                      <tr>
                        <th className="border-0">ID</th>
                        <th className="border-0">Name</th>
                        <th className="border-0">Email</th>
                        <th className="border-0">Role</th>
                        <th className="border-0 text-center">Status</th>
                        <th className="border-0 text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="text-muted mt-2 small">Loading users...</p>
                          </td>
                        </tr>
                      ) : currentItems.length > 0 ? (
                        currentItems.map((student, index) => (
                          <tr key={index}>
                            <td className="text-muted small">#{student.id}</td>
                            <td className="fw-bold">{student.name}</td>
                            <td className="small">{student.email}</td>
                            <td>
                              <span className="badge bg-light text-primary border border-primary border-opacity-10 py-1 px-2 fw-normal">
                                {student.role}
                              </span>
                            </td>
                            <td className="text-center">
                              {student.account_status === "Active" ? (
                                <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 py-1 px-3 rounded-pill fw-normal">Active</span>
                              ) : (
                                <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 py-1 px-3 rounded-pill fw-normal">Inactive</span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-1">
                                <Link to={`/read/${student.id}`} className="btn btn-outline-info btn-sm p-1 px-2" title="View Details">
                                  <i className="fa-solid fa-book small" />
                                </Link>
                                <Link to={`/edit/${student.id}`} className="btn btn-outline-primary btn-sm p-1 px-2" title="Edit">
                                  <i className="fa-solid fa-pen small" />
                                </Link>
                                <button onClick={() => confirmDelete(student.id)} className="btn btn-outline-danger btn-sm p-1 px-2" title="Delete">
                                  <i className="fa-solid fa-trash small" />
                                </button>
                                {student.account_status === "Active" ? (
                                  <button onClick={() => handleDeactivate(student.id)} className="btn btn-outline-warning btn-sm px-2 small" style={{ fontSize: '11px' }}>
                                    Deactivate
                                  </button>
                                ) : (
                                  <button onClick={() => handleActivate(student.id)} className="btn btn-outline-success btn-sm px-2 small" style={{ fontSize: '11px' }}>
                                    Activate
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-5 text-muted fst-italic">
                            No users found matching your search.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
                {renderPaginationFooter()}
              </Card.Body>
            </Card>
          </div>
        </main>
      </div>
    </>
  );
}